var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsvg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 162,
    viewBox: "0 0 161 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_141_11083)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_141_11083)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 12,
    width: 114.739,
    height: 114.739,
    rx: 5.73696,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_141_11083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.9 43.668C119.554 43.7338 122.741 50.8548 118.74 54.8546L105.208 68.3784L98.8438 72.5822L80.3708 43.668H113.9ZM57.7952 70.6386C57.2025 71.2311 56.7324 71.9345 56.4116 72.7087C56.0909 73.4829 55.9258 74.3128 55.9258 75.1508C55.9258 75.9888 56.0909 76.8186 56.4116 77.5929C56.7324 78.3671 57.2025 79.0705 57.7952 79.663L71.3415 93.2046C72.5395 94.402 74.1639 95.0746 75.8577 95.0746C77.5515 95.0746 79.176 94.402 80.374 93.2046L77.9613 87.0394L64.3073 72.5822L57.7936 70.6353L57.7952 70.6386Z",
    fill: "#31BF5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0001 54.8546C37.9987 50.8548 41.1873 43.7338 46.8416 43.668H80.3694L105.205 68.3784C105.798 68.971 106.269 69.6746 106.59 70.4492C106.911 71.2237 107.076 72.0539 107.076 72.8923C107.076 73.7307 106.911 74.5609 106.59 75.3354C106.269 76.1099 105.798 76.8136 105.205 77.4061L89.3987 93.2013C88.2008 94.3978 86.577 95.0698 84.884 95.0698C83.191 95.0698 81.5672 94.3978 80.3694 93.2013L42.0001 54.8546Z",
    fill: "#FBD500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3695 93.2029C80.9626 92.6104 81.4332 91.9067 81.7542 91.1322C82.0753 90.3577 82.2405 89.5275 82.2405 88.6891C82.2405 87.8507 82.0753 87.0205 81.7542 86.246C81.4332 85.4715 80.9626 84.7678 80.3695 84.1753L66.8216 70.637C65.6236 69.4395 63.9991 68.7669 62.3053 68.7669C60.6115 68.7669 58.987 69.4395 57.7891 70.637L80.3695 93.2029ZM68.5147 55.404L80.3695 43.668L95.0451 58.2247C93.2481 56.4295 90.812 55.4211 88.2719 55.4211C85.7319 55.4211 83.2957 56.4295 81.4988 58.2247L76.4179 63.3008C75.3696 64.3484 73.9483 64.9369 72.4663 64.9369C70.9843 64.9369 69.5629 64.3484 68.5147 63.3008C67.9959 62.7824 67.5844 62.1669 67.3037 61.4894C67.0229 60.8119 66.8784 60.0857 66.8784 59.3524C66.8784 58.619 67.0229 57.8928 67.3037 57.2154C67.5844 56.5379 67.9959 55.9223 68.5147 55.404Z",
    fill: "#005E7A"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_141_11083",
    x: 0.0521603,
    y: 0.52608,
    width: 160.635,
    height: 160.635,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.4739
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.4739
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_141_11083"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_141_11083",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_141_11083"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 12,
    width: 114.739,
    height: 114.739,
    rx: 5.73696,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_141_11083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.3174,
    height: 80.3174,
    fill: "white",
    transform: "translate(40.2109 29.2109)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsvg3);
export default __webpack_public_path__ + "static/media/icon.svg-3.6c76fce5c7b2a50b1105e562aaf25147.svg";
export { ForwardRef as ReactComponent };